import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-s-cascader',
  templateUrl: './s-cascader.component.html',
  styleUrls: ['./s-cascader.component.less']
})
export class SCascaderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
